import styled from 'styled-components';
import { COLORS } from '@/theme';

export const StyledBlockPaletteRoot = styled.div`
  .ant-card {
    background: ${COLORS.GRAY_94};
    border-color: ${COLORS.LIGHT_GRAY_2};
  }

  .ant-card-head {
    min-height: auto;
    background: ${COLORS.GRAY_94};
    border-bottom-color: ${COLORS.SOFT_GRAY};
  }

  .ant-card-head-title {
    padding: 10px 0;
    color: ${COLORS.BLACK_PRIMARY};
  }

  .ant-card-body {
    background: ${COLORS.BRIGHT_GRAY};
    padding: 12px;
  }

  .ant-btn.template-button.ant-btn-text {
    background: ${COLORS.WHITE} !important;
    color: ${COLORS.BLACK_PRIMARY} !important;
    border: 1px solid ${COLORS.SOFT_GRAY} !important;
    box-shadow: none !important;

    &:hover,
    &:focus-visible {
      background: ${COLORS.YELLOW_PRIMARY} !important;
      color: ${COLORS.BLACK_PRIMARY} !important;
      border-color: ${COLORS.SOFT_GRAY} !important;
    }

    &:active {
      background: ${COLORS.PALE_YELLOW} !important;
    }
  }
`;
